import { render, staticRenderFns } from "./SatisfactionPerQuestionForExecutives.vue?vue&type=template&id=2818488a&scoped=true"
import script from "./SatisfactionPerQuestionForExecutives.vue?vue&type=script&lang=js"
export * from "./SatisfactionPerQuestionForExecutives.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionPerQuestionForExecutives.vue?vue&type=style&index=0&id=2818488a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818488a",
  null
  
)

export default component.exports